import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HeaderRow from './HeaderRow';
import PanelDetails from './PanelDetails';
import { toCamelCase } from '@defi/core-utils';
const styles = theme => ({
  wrapper: {
    height: 'calc(100% - 65px)',
    maxWidth: '100%',
    overflowX: 'hidden'
  },
  summary: {
    height: '48px !important',
    minHeight: '48px !important',
    fontWeight: 'bold'
  },
  background: {
    margin: 0,
    backgroundColor: '#fff',
    border: '1px solid #eee'
  },
  details: {
    borderTop: '1px solid #dedede',
    borderBottom: '1px solid #ccc'
  }
});
export const buildTestClass = _ref => {
  let id = _ref.id,
    title = _ref.title;
  return "defiExpansion-".concat(id, "-panel-").concat(toCamelCase(title));
};
const DefiExpansion = props => {
  const renderPanels = () => {
    return props.children.get('rows').map((row, i) => {
      return /*#__PURE__*/React.createElement(ExpansionPanel, {
        className: props.classes.background,
        expanded: props.expandedPanels[row.get('id')],
        onClick: () => null,
        key: i,
        "data-testid": buildTestClass({
          id: row.get('id'),
          title: row.get('title')
        })
      }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
        expandIcon: /*#__PURE__*/React.createElement("div", null),
        className: props.classes.summary,
        "data-testid": buildTestClass({
          id: row.get('id'),
          title: 'Summary'
        })
      }, row.get('title')));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: props.classes.wrapper
  }, /*#__PURE__*/React.createElement(HeaderRow, {
    columns: props.children.get('headers')
  }), renderPanels());
};
export default withStyles(styles)(DefiExpansion);